var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'pb-row': true,
    direction: _vm.direction,
    fullHeight: _vm.fullHeight
  }, _obj[("justify-" + _vm.justify)] = true, _obj[("align-" + _vm.align)] = true, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }